import React, { useContext, useState } from 'react'
import { TipsContext, DrawPageStateContext, BaseConfigContext, InsertContext, GlobalStoreContext } from '@/context'
import { useNavigate } from 'react-router-dom'
import './index.less'


export default function Navigator() {
    const { isLogin, userInfo } = useContext(GlobalStoreContext)
    const { currentModule } = useContext(DrawPageStateContext)
    const { insertList } = useContext(InsertContext)
    const { maxSize } = useContext(BaseConfigContext)
    const { useModal, useMessage } = useContext(TipsContext)
    const [testListTOTOTOTOTO, setTestListTOTOTOTOTO] = useState([])
    const navigate = useNavigate()
    const { modal } = useModal()
    const createReleaseData = () => {
        let result = null
        if (currentModule !== null && insertList.length > 0) {
            result = {
                baseConfig: maxSize,
                code: currentModule.code,
                name: currentModule.name,
                plugins: insertList,
            }
        }
        return result
    }
    return (
        <div
            className="navigator"
        >
            <div className="left-area">
                <img src={require('@/assets/imgs/logo.png')} alt="" />
                <div className="name">TGB科技画布工具后台管理系统</div>
            </div>

            <div className="right-area">
                <div className="line"></div>
                <div className="login-area">
                    <div className="flex-row items-center">
                        <img className="avatar" src={require('@/assets/imgs/logo.png')} alt="" />
                        <span className="name">太基保科技官方旗舰店</span>
                    </div>
                </div>
            </div>
        </div>
    )
}